module.exports = __webpack_public_path__ + "img/background.e0bd2d1e.webp";